import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
export var LoggedInUserLinks =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LoggedInUserLinks, _PureComponent);

  function LoggedInUserLinks() {
    _classCallCheck(this, LoggedInUserLinks);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoggedInUserLinks).apply(this, arguments));
  }

  _createClass(LoggedInUserLinks, [{
    key: "handleLogoutClick",

    /* istanbul ignore next */
    value: function handleLogoutClick(event) {
      event.preventDefault();
      var form = document.createElement('form');
      form.action = '/logout';
      form.method = 'POST';
      document.body.appendChild(form);
      form.submit();
    }
  }, {
    key: "render",
    value: function render() {
      var canViewUnifiedSearch = this.props.canViewUnifiedSearch;
      return React.createElement(Fragment, null, canViewUnifiedSearch && React.createElement("li", null, React.createElement(Link, {
        to: "/search"
      }, React.createElement(FormattedMessage, {
        id: "header.link.search",
        defaultMessage: "Find a class"
      }))), React.createElement("li", null, React.createElement("a", {
        href: "/settings/membership"
      }, React.createElement(FormattedMessage, {
        id: "accountDropdown.accountLink",
        defaultMessage: "Settings"
      }))), React.createElement("li", null, React.createElement("a", {
        href: "/logout",
        onClick: this.handleLogoutClick
      }, React.createElement(FormattedMessage, {
        id: "accountDropdown.logoutLink",
        defaultMessage: "Log out"
      }))));
    }
  }]);

  return LoggedInUserLinks;
}(PureComponent);
LoggedInUserLinks.propTypes = {
  canViewUnifiedSearch: PropTypes.bool
};